import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IrbCommonModule} from "@irb-common/irb-common.module";
import {DialogPrCostBasisComponent} from './dialog-pr-cost-basis/dialog-pr-cost-basis.component';
import {DialogPrExplanationComponent} from './dialog-pr-explanation/dialog-pr-explanation.component';
import {DialogPrAuditComponent} from './dialog-pr-audit/dialog-pr-audit.component';
import {DialogPrExportPdfComponent} from './dialog-pr-export-pdf/dialog-pr-export-pdf.component';
import {DialogPrResubmitComponent} from './dialog-pr-resubmit/dialog-pr-resubmit.component';
import {CdkTableModule} from '@angular/cdk/table';
import {MatSortModule} from '@angular/material/sort';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DialogShowSecurityUsageWarningComponent} from '@irb/irb-dialogs/dialog-show-security-usage-warning/dialog-show-security-usage-warning.component';
import {DialogDeleteComponentSecuritiesComponent} from '@irb/irb-dialogs/dialog-delete-component-securities/dialog-delete-component-securities.component';
import { DialogAnnouncementEditComponent } from './dialog-announcement-edit/dialog-announcement-edit.component';
import { DialogAnnouncementsComponent } from './dialog-announcements/dialog-announcements.component';
import { DialogPrManualAdjustmentComponent } from './dialog-pr-manual-adjustment/dialog-pr-manual-adjustment.component';
import { DialogPrThresholdExceededComponent } from './dialog-pr-threshold-exceeded/dialog-pr-threshold-exceeded.component';
import { DialogFinmasonTrainSsoComponent } from './dialog-finmason-train-sso/dialog-finmason-train-sso.component';
import {DialogWashSaleComponent} from "@irb/irb-dialogs/dialog-washsale-info/dialog-washsale-info.component";
import { DialogPortfolioCustomLabelsModifyComponent } from './dialog-portfolio-custom-labels-modify/dialog-portfolio-custom-labels-modify.component';
import { DialogPortfolioCustomLabelsModifyNoRowComponent } from './dialog-portfolio-custom-labels-modify/dialog-portfolio-custom-labels-modify.no-rows.component';
import { DialogPortfolioMultieditViewComponent } from './dialog-portfolio-multiedit-view/dialog-portfolio-multiedit-view.component';
import { DialogAccountMultieditViewComponent } from './dialog-account-multiedit-view/dialog-account-multiedit-view.component';
import { DialogPrExportPdfLegacyComponent } from './dialog-pr-export-pdf-legacy/dialog-pr-export-pdf-legacy.component';
import { DialogQoeResultComponent } from './dialog-qoe-result/dialog-qoe-result.component';

@NgModule({
    declarations: [
        DialogPrCostBasisComponent,
        DialogPrExplanationComponent,
        DialogPrAuditComponent,
        DialogPrExportPdfComponent, DialogPrResubmitComponent,
        DialogShowSecurityUsageWarningComponent,
        DialogDeleteComponentSecuritiesComponent,
        DialogAnnouncementEditComponent,
        DialogAnnouncementsComponent,
        DialogPrManualAdjustmentComponent,
        DialogPrThresholdExceededComponent,
        DialogFinmasonTrainSsoComponent,
        DialogWashSaleComponent,
        DialogPortfolioCustomLabelsModifyComponent,
        DialogPortfolioCustomLabelsModifyNoRowComponent,
        DialogPortfolioMultieditViewComponent,
        DialogAccountMultieditViewComponent,
        DialogPrExportPdfLegacyComponent,
        DialogQoeResultComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IrbCommonModule,
        CdkTableModule,
        MatSortModule,
        MatTooltipModule
    ],
    exports: [
        DialogPrCostBasisComponent,
        DialogPrExplanationComponent,
        DialogPrAuditComponent,
        DialogPrExportPdfComponent,
        DialogShowSecurityUsageWarningComponent,
        DialogDeleteComponentSecuritiesComponent,
        DialogWashSaleComponent
    ]
})
export class IrbDialogsModule {
}
